<template>
  <v-ons-navigator swipeable :page-stack="page_stack" @push-page="page_stack.push($event)"></v-ons-navigator>
</template>

<script>
  import CalcPage from './CalcPage'

  export default {
    name: 'calc-tab',
    data () {
      return {
        page_stack: [CalcPage],
        name: 'calc-tab'
      }
    },
    mounted: function () {
      let thisComponent = this
      document.addEventListener('clearPageStack', e => {
        if (e.detail === thisComponent.name) {
          for (let i = thisComponent.page_stack.length; i > 1; --i) {
            thisComponent.page_stack.pop()
          }
        }
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcTab.vue